import { InlineEmptyStateOnboarding } from "@octopusdeploy/design-system-components";
import { NoArgoCDApplicationsIllustration } from "~/areas/infrastructure/components/ArgoCDInstances/components/NoArgoCDApplicationsIllustration";
import { ExternalLinkSlugs } from "../ArgoCDConstants";
type EmptyStateNoScopedArgoCDApplicationsProps = {
    onGenerateAnnotationsClick: () => void;
};
export const EmptyStateNoScopedArgoCDApplications = (props: EmptyStateNoScopedArgoCDApplicationsProps) => (<InlineEmptyStateOnboarding illustration={"Custom"} image={<NoArgoCDApplicationsIllustration />} title={"No Argo CD applications found matching the current scope"} description={"Start by adding annotations to your Argo CD applications to map them to Octopus projects, environments and tenants."} actions={{
        primary: {
            type: "button",
            label: "Add Applications",
            onClick: props.onGenerateAnnotationsClick,
        },
    }} learnMore={{
        label: "Docs: Argo CD",
        path: ExternalLinkSlugs.AnnotationsDocs,
    }}/>);
